import React, { Component } from "react";
import Dialog from "../dialog";
import DialogInput from "../input";
import LanguageInput from "../languagesinput";
import SelectConfigInput from "../selectconfig";


class EditTranscription extends Dialog
{
  constructor(props) 
  {
    super(props);

    var title = {
        en:"Edit a transcription file", 
        fr:"Modifier un fichier transcription",
      };

    if ((this.props.asset.astype === 4) || (this.props.asset.astype===5))
      title = {
        en:"Edit a subtitle file", 
        fr:"Modifier un fichier de sous-titres",
      };

    if (this.props.asset.astype === 7) 
      title = {
        en:"Edit a AudioDescription/V.O. file", 
        fr:"Modifier un fichier d'audio description/v.o.",
      };

    if (this.props.asset.astype === 8) 
      title = {
        en:"Edit a sequence file", 
        fr:"Modifier un fichier de séquences",
      };

    this.state.title = title;
    this.state.tobecenter = true;

    this.state.buttons = 
    [
      //{type:"text", disabled:true,text:{fr:"Accepter",en:"Accept"},key:"accept"},
      //{type:"text", disabled:false,text:{fr:"Refuser",en:"Decline"}, key:"decline"},
      {type:"back", disabled:false},
      {type:"ok", disabled:true},
      
    ]

    this.handleButton =  this.handleButton.bind(this);

    this.formulaire = 
      {
        id: this.props.asset.asid,
        title: this.props.asset.astitle,
        type: this.props.asset.astype,
        filename: this.props.asset.asfile,
        uploadfile: null,
        ext: this.props.asset.asext,
        subtype:this.props.asset.assubtype,
        orititle: this.props.orititle,
        language: this.props.asset.aslang,
        framerate: "",
        timecode: this.props.asset.astimecode,
        config: this.props.asset.ascoid,
      }

      

      
      var framerate = this.props.asset.asframerate.toFixed(2).replace('.', ','); // "1234,56"
      framerate = framerate + " (" + this.props.asset.asnum+"/"+this.props.asset.asden+")";
      this.formulaire.framerate = framerate;
      
      

  
      this.titleRef = React.createRef();
      this.orititleRef = React.createRef();
      this.languageRef = React.createRef();
      this.extRef = React.createRef();
      this.filenameRef = React.createRef();
      this.framerateRef = React.createRef();
      this.timecodeRef = React.createRef();

      

      this.handleOnChange = this.handleOnChange.bind(this);

      this.onQuit = this.onQuit.bind(this)
      this.onValid = this.onValid.bind(this)


   
    
  }
  
  onValid()
  {
    
  }

  onQuit()
  {
    this.props.onButton("back", this.formulaire);    
  }

  

  handleOnChange()
  {
      this.formulaire.title = this.titleRef.current.getValue();
      this.formulaire.language = this.languageRef.current.getValue();

      
      




      if (this.formulaire.title.trim() != "")
        {
        this.setDisabledButtonByType("ok", false);
        this.setDisabledButtonByKey("accept", false);
      }
      else
      {
        this.setDisabledButtonByType("ok", true);
        this.setDisabledButtonByKey("accept", true);
      }

      
  }

  componentDidMount()
  {
    super.componentDidMount();
      if ((this.framerateRef) && (this.framerateRef.current))
        this.framerateRef.current.setValue(this.formulaire.framerate);
  }

  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)
    this.props.onButton(buttonkey, this.formulaire);

    
  }

  render()
  {


    const retour =
    (
      <>
      <br/>
        <DialogInput
          value = {this.formulaire.title}
          disabled={false}
          autoFocus = {true}
          title = {this.context.language=="fr"?"Titre":"Title"}
          width = "400px"
          ref = {this.titleRef}
          onChange =  {this.handleOnChange}

        />
    <br/>
    <DialogInput
                value = {this.formulaire.orititle}
                disabled={false}
                autoFocus = {false}
                ref = {this.filenameRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "400px"
                title = {this.context.language=="fr"?"Fichier Original":"Original file"}
              />
        <br/>

      <DialogInput
                value = {this.formulaire.filename}
                disabled={false}
                autoFocus = {false}
                ref = {this.filenameRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "400px"
                title = {this.context.language=="fr"?"Fichier":"File"}
              />
        <br/>

        <DialogInput
                value = {this.formulaire.ext}
                disabled={false}
                autoFocus = {false}
                ref = {this.extRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "100px"
                title = {this.context.language=="fr"?"Extension":"Extension"}
              />

        <LanguageInput
                value = {this.formulaire.language}
                disabled={false}
                autoFocus = {false}
                ref = {this.languageRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                title = {this.context.language=="fr"?"Langage":"Language"}
              />

        <SelectConfigInput
            coid = {this.formulaire.config}
            disabled={false}
            onChange =  {this.handleOnChange}
            autoFocus = {false}

            readOnly = {true}
            width = {400}
            title = {this.context.language=="fr"?"Configuration":"Configuration"}
            />


      <DialogInput
                value = {this.formulaire.framerate}
                disabled={false}
                autoFocus = {false}
                ref = {this.framerateRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "190px"
                align="center"
                title = {this.context.language=="fr"?"Frame Rate":"Frame Rate"}/>

      <DialogInput
                value = {this.formulaire.timecode}
                disabled={false}
                autoFocus = {false}
                ref = {this.timecodeRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "190px"
                align="center"
                title = {this.context.language=="fr"?"Premier time code":"Time code start"}/>
      

      </>
    )

    return super.render(retour);
  }


}


export default EditTranscription;